<template>
  <Layout>
    <div class="CounterUpPage">
      <div class="CounterUpPage_content">
        <div class="staticBanner" v-for="(item, index) in Bannerlist[val - 1]" :key="index">
          <img class="img-bg" :src="item.bg" alt="">
          <div class="text color-white" data-aos="fade-up">
            <h4 class="staticimg-title color-white fs-1">{{ item.title }}</h4>
            <div class="staticimg-content fs-3">合规前移，业财融合，数据驱动，重构优势</div>
            <div class="input-btn">
              <input class="input" type="text" placeholder="请输入您的手机号码">
              <button class="free-btn btn" @click="orderShow">免费试用</button>
            </div>
            <div class="scroll">
              <div class="fs-3">500+ 大型集团企业共同选择</div>
              <div class="company animate__animated">
                <vue-seamless-scroll :data="companyall" :class-option="defaultOption">
                  <div class="companymain">
                    <div class="companyitem" v-for="(log, j) in companyall">
                      <img class="logoimg" :src="log.logo" alt="">
                    </div>
                  </div>
                </vue-seamless-scroll>
              </div>
            </div>
          </div>
        </div>
        <dropdownMenu :pkname="'集团企业云EECloud'" @func="title" :type="val" :pktype="'counter'"></dropdownMenu>
        <div class="titles" v-if="windowWidth>767">
          <div class="in_titles">
            <div class="in_titles_left">
              <img class="in_titles_left_img" src="../assets/images/industry/tb.png" alt="" />
              <div><span style="margin-right: 10px">&gt;</span><span style="font-size: 18px">集团企业云EECloud</span></div>
            </div>
            <div class="in_titles_right">
              <a :class="val == '1' ? 'changes' : ''" @click="title('1')">智慧业财一体化云</a>
              <a :class="val == '2' ? 'changes' : ''" @click="title('2')">智慧财务共享(中台)云</a>
              <a :class="val == '3' ? 'changes' : ''" @click="title('3')">税务管理云</a>
              <a :class="val == '4' ? 'changes' : ''" @click="title('4')">全球司库管理云</a>
              <a :class="val == '5' ? 'changes' : ''" @click="title('5')">智慧网银云</a>
              <a :class="val == '6' ? 'changes' : ''" @click="title('6')">全面预算管理云</a>
              <a :class="val == '7' ? 'changes' : ''" @click="title('7')">智能分析云</a>
            </div>
          </div>
        </div>
        <div class="content_body container">
          <div class="group_mid" v-for="(item, index) in groupData[val - 1]" :key="index">
            <div class="mid_top rn-section-gap" data-aos="fade-up">
              <h3 class="mid_top_title fs-1 text-center">{{ item.topTitle }}</h3>
              <div class=" fs-3 text-center">{{ item.text }}</div>
            </div>
            <div class="mid_bot">
              <img :src="item.img1" alt="" style="margin-bottom:3rem" />
            </div>
            <div class=" text-center">
              <div class="mid_top_btn fs-3 " @click="goRouter">立即咨询</div>
            </div>
            <div class="mid_bot">
              <img :src="item.img2" alt="" style="margin-top:3rem" />
            </div>
          </div>
        </div>
        <div class="model">
          <ModelBox :val="val" :claWidth="claWidth" :modelBox="modelBox"></ModelBox>
        </div>
        <div class="valueAll">
          <div class="rn-section-gap text-center color-white" data-aos="fade-up">
            <div class="fs-1 w-700">整体价值</div>
            <div class="fs-3">合规前移，业财融合，数据驱动，重构优势</div>
          </div>
          <div class="valueBox" v-if="windowWidth>767">
            <div class="inBtn row container" v-if="val!=4">
              <div class="inBtnBox col-12 card_list" v-for="(item, index) in valueBox[val - 1]" :key="index"
                :style="{ width: (valueBox[val - 1].length == 2 ? '50%' : valueBox[val - 1].length == 3 ? '33.3%' : '25%') }">
                <div class="inBox_text">
                  <img class="inBox_text_img1" :src="item.img1" alt="" />
                  <img class="inBox_text_img2" :src="item.img2" alt="" />
                  <div class="inBox_text_title">{{ item.title }}</div>
                </div>
                <div class="inBox_content text-center">{{ item.content }}<br />{{ item.content2 }}</div>
                <div></div>
              </div>
              <div></div>
            </div>
            <div class="inBtn container inBtn5" v-if="val==4">
              <div class="inBtnBox col-lg-3 col-12 card_list" v-for="(item, index) in valueBox4" :key="index">
                <div class="inBox_text">
                  <img class="inBox_text_img1" :src="item.img1" alt="" />
                  <img class="inBox_text_img2" :src="item.img2" alt="" />
                  <div class="inBox_text_title">{{ item.title }}</div>
                </div>
                <div class="inBox_content text-center">{{ item.content }}<br />{{ item.content2 }}</div>
                <div></div>
              </div>
            </div>
          </div>
          <div class="valueBox" v-else>
            <swiper class="inBtn container" :options="swiperOptionAll" >
              <swiper-slide class="inBtnBox col-12 card_list" v-for="(item, index) in valueBox[val - 1]" :key="index">
                <div class="inBox_text">
                  <img class="inBox_text_img1" :src="item.img1" alt="" />
                  <img class="inBox_text_img2" :src="item.img2" alt="" />
                  <div class="inBox_text_title fs-3">{{ item.title }}</div>
                </div>
                <div class="inBox_content text-center fs-text">{{ item.content }}<br />{{ item.content2 }}</div>
              
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div class="values">
          <div class="tab-block pt-lyd-120 container ind" data-aos="fade-up">
            <h3 class="fs-1 fw-bold text-center lyd-title-colo1">产品优势</h3>
            <p class="fs-3 text-center lyd-title-colo1">合规前移，业财融合，数据驱动，重构优势</p>
          </div>
          <div class="valuesBoxs container">
            <div class="valuesBoxsbg_img" v-for="(item, index) in valuesBoxs[val - 1]" :key="index">
              <img class="valuesBoxs_img" :src="item.image" alt="" />
            </div>
            <div class="value" v-if="windowWidth > 767">
              <div class="valueBoxes">
                <swiper class="mySwipe swiper-no-swiping" :options="swiperOption" ref="Swipers">
                  <swiper-slide v-for="(item, index) in valueData" :key="index">
                    <div class="valueBox">
                      <div class="valueBoxContent">
                        <h4 class="text-white">{{ item.title }}</h4>
                        <p class="text-white">{{ item.content }}</p>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
                <div id="swiper-pagination">
                  <div :id="Number(index) + 1" class="swiperBox" v-for="(item, index) in valueData" :key="index">
                    <span :id="Number(index) + 1 + '1'" class="swiperBox_line"></span>
                    <span :id="Number(index) + 1 + '2'" class="swiperBox_content">{{ "0" + (Number(index) + 1) }}</span>
                  </div>
                </div>
                <!-- <div class="swiper-pagination4" slot="pagination"></div> -->
              </div>
            </div>
            <div class="valuer" v-else>
              <div class="valueBoxes">
                <swiper class="mySwipe" :options="swiperOptions" ref="videoSwiper">
                  <swiper-slide v-for="(item, index) in valueData" :key="index">
                    <div class="valueBox">
                      <div class="valueBoxContent">
                        <h4 class="text-white fs-1">{{ item.title }}</h4>
                        <p class="text-white">{{ item.content }}</p>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
                <div class="swiper-pagination1" slot="pagination"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottomCard container">
          <div class="rn-section-gap text-center" data-aos="fade-up">
            <div class="fs-1 w-700">相关案例</div>
            <div class="fs-3">合规前移，业财融合，数据驱动，重构优势</div>
          </div>
          <ListCard v-if="windowWidth>767" :demo-pages="demoPages[val-1]" :demo-class="demoClass"></ListCard>
          <ListCard v-else :type="2" :demo-pages="demoPages[val-1]" :demo-class="demoClass"></ListCard>
        </div>
      </div>
      <div class="order-show" v-if="shows">
        <order-show @close="close"></order-show>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../components/common/Layout"
import StaticBanner from "@/components/common/staticBanner/index.vue"
import ListCard from "@/components/common/relatedCases/listCard"
import ModelBox from "@/components/common/counter/ModelBox.vue"
import dropdownMenu from "@/components/common/dropdownMenu.vue"
import "swiper/dist/css/swiper.css"
import { swiper, swiperSlide } from "vue-awesome-swiper"
import vueSeamlessScroll from 'vue-seamless-scroll'
import OrderShow from '@/components/common/dialog/orderShow.vue'
export default {
  name: "CounterUpPage",
  components: { Layout, StaticBanner, ListCard, swiper, swiperSlide, ModelBox, vueSeamlessScroll, dropdownMenu,OrderShow },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth,
      
      Bannerlist: [
        [
          {
            bg: require('@/assets/images/portfolio/esc/banner-01.png'),
            title: '智慧业财一体化云',
            title2: ''
          }
        ],
        [
          {
            bg: require('@/assets/images/portfolio/esc/banner-02.png'),
            title: '智慧财务共享(中台)云',
            title2: ''
          }
        ],
        [
          {
            bg: require('@/assets/images/portfolio/esc/banner-03.png'),
            title: '税务管理云',
            title2: ''
          }
        ],
        [
          {
            bg: require('@/assets/images/portfolio/esc/banner-04.png'),
            title: '全球司库管理云',
            title2: ''
          }
        ],
        [
          {
            bg: require('@/assets/images/portfolio/esc/banner-04.png'),
            title: '智慧网银云',
            title2: ''
          }
        ],
        [
          {
            bg: require('@/assets/images/portfolio/esc/banner-04.png'),
            title: '全面预算管理云',
            title2: ''
          }
        ],
        [
          {
            bg: require('@/assets/images/portfolio/esc/banner-04.png'),
            title: '智能分析云',
            title2: ''
          }
        ],
      ],
      demoPages: [
        [
          {
          url: "/success-detail/1",
          image: require("@/assets/images/casesimg/guolv-new.png"),
          imageLight: require("@/assets/images/casesimg/guolv-new.png"),
          title: "中国国旅",
          content: "全球化财务共享中心管理",
        },
        {
          url: "/success-detail/2",
          image: require("@/assets/images/casesimg/botian-new.png"),
          imageLight: require("@/assets/images/casesimg/botian-new.png"),
          title: "博天环境 ",
          content: "智慧业财新共享平台",
        },
        {
          url: "/success-detail/3",
          image: require("@/assets/images/casesimg/shanghai-baoye.png"),
          imageLight: require("@/assets/images/casesimg/shanghai-baoye.png"),
          title: "上海宝冶",
          content: "打造一流的最具竞争优势核心理念",
        },
        {
          url: "/success-detail/4",
          image: require("@/assets/images/casesimg/zhongliang.png"),
          imageLight: require("@/assets/images/casesimg/zhongliang.png"),
          title: "中梁控股集团",
          content: "支持中梁未来3000亿规模发展",
        },
        ],
        [
          {
          url: "/success-detail/2",
          image: require("@/assets/images/casesimg/botian-new.png"),
          imageLight: require("@/assets/images/casesimg/botian-new.png"),
          title: "博天环境 ",
          content: "智慧业财新共享平台",
        },
        {
          url: "/success-detail/3",
          image: require("@/assets/images/casesimg/shanghai-baoye.png"),
          imageLight: require("@/assets/images/casesimg/shanghai-baoye.png"),
          title: "上海宝冶",
          content: "打造一流的最具竞争优势核心理念",
        },
        {
          url: "/success-detail/4",
          image: require("@/assets/images/casesimg/zhongliang.png"),
          imageLight: require("@/assets/images/casesimg/zhongliang.png"),
          title: "中梁控股集团",
          content: "支持中梁未来3000亿规模发展",
        },
        {
          url: "/success-detail/5",
          image: require("@/assets/images/casesimg/enfei-new.png"),
          imageLight: require("@/assets/images/casesimg/enfei-new.png"),
          title: "中国恩菲",
          content: "财务共享平台加速中国恩菲一路一带",
        },
        ],
        [
          {
          url: "/success-detail/3",
          image: require("@/assets/images/casesimg/shanghai-baoye.png"),
          imageLight: require("@/assets/images/casesimg/shanghai-baoye.png"),
          title: "上海宝冶",
          content: "打造一流的最具竞争优势核心理念",
        },
        {
          url: "/success-detail/4",
          image: require("@/assets/images/casesimg/zhongliang.png"),
          imageLight: require("@/assets/images/casesimg/zhongliang.png"),
          title: "中梁控股集团",
          content: "支持中梁未来3000亿规模发展",
        },
        {
          url: "/success-detail/5",
          image: require("@/assets/images/casesimg/enfei-new.png"),
          imageLight: require("@/assets/images/casesimg/enfei-new.png"),
          title: "中国恩菲",
          content: "财务共享平台加速中国恩菲一路一带",
        },
        {
          url: "/success-detail/6",
          image: require("@/assets/images/casesimg/zhongye-zhiye.png"),
          imageLight: require("@/assets/images/casesimg/zhongye-zhiye.png"),
          title: "中冶置业",
          content: "地产企业业财融合智慧创新管理标杆",
        },
        ],
        [
          {
          url: "/success-detail/4",
          image: require("@/assets/images/casesimg/zhongliang.png"),
          imageLight: require("@/assets/images/casesimg/zhongliang.png"),
          title: "中梁控股集团",
          content: "支持中梁未来3000亿规模发展",
        },
        {
          url: "/success-detail/5",
          image: require("@/assets/images/casesimg/enfei-new.png"),
          imageLight: require("@/assets/images/casesimg/enfei-new.png"),
          title: "中国恩菲",
          content: "财务共享平台加速中国恩菲一路一带",
        },
        {
          url: "/success-detail/6",
          image: require("@/assets/images/casesimg/zhongye-zhiye.png"),
          imageLight: require("@/assets/images/casesimg/zhongye-zhiye.png"),
          title: "中冶置业",
          content: "地产企业业财融合智慧创新管理标杆",
        },
        {
          url: "/success-detail/7",
          image: require("@/assets/images/casesimg/jiaotong.png"),
          imageLight: require("@/assets/images/casesimg/jiaotong.png"),
          title: "中冶交通",
          content: "智能业财管理助力财务管控更高效",
        },
        ],
        [
          {
          url: "/success-detail/5",
          image: require("@/assets/images/casesimg/enfei-new.png"),
          imageLight: require("@/assets/images/casesimg/enfei-new.png"),
          title: "中国恩菲",
          content: "财务共享平台加速中国恩菲一路一带",
        },
        {
          url: "/success-detail/6",
          image: require("@/assets/images/casesimg/zhongye-zhiye.png"),
          imageLight: require("@/assets/images/casesimg/zhongye-zhiye.png"),
          title: "中冶置业",
          content: "地产企业业财融合智慧创新管理标杆",
        },
        {
          url: "/success-detail/7",
          image: require("@/assets/images/casesimg/jiaotong.png"),
          imageLight: require("@/assets/images/casesimg/jiaotong.png"),
          title: "中冶交通",
          content: "智能业财管理助力财务管控更高效",
        },
        {
          url: "/success-detail/8",
          image: require("@/assets/images/casesimg/huaxiafenmo.png"),
          imageLight: require("@/assets/images/casesimg/huaxiafenmo.png"),
          title: "华夏粉末冶金",
          content: "业财一体化应用为制造企业转型升级赋能",
        },
        ],
        [
          {
          url: "/success-detail/6",
          image: require("@/assets/images/casesimg/zhongye-zhiye.png"),
          imageLight: require("@/assets/images/casesimg/zhongye-zhiye.png"),
          title: "中冶置业",
          content: "地产企业业财融合智慧创新管理标杆",
        },
        {
          url: "/success-detail/7",
          image: require("@/assets/images/casesimg/jiaotong.png"),
          imageLight: require("@/assets/images/casesimg/jiaotong.png"),
          title: "中冶交通",
          content: "智能业财管理助力财务管控更高效",
        },
        {
          url: "/success-detail/8",
          image: require("@/assets/images/casesimg/huaxiafenmo.png"),
          imageLight: require("@/assets/images/casesimg/huaxiafenmo.png"),
          title: "华夏粉末冶金",
          content: "业财一体化应用为制造企业转型升级赋能",
        },
        {
          url: "/success-detail/1",
          image: require("@/assets/images/casesimg/guolv-new.png"),
          imageLight: require("@/assets/images/casesimg/guolv-new.png"),
          title: "中国国旅",
          content: "全球化财务共享中心管理",
        }
        ],
        [
          {
          url: "/success-detail/7",
          image: require("@/assets/images/casesimg/jiaotong.png"),
          imageLight: require("@/assets/images/casesimg/jiaotong.png"),
          title: "中冶交通",
          content: "智能业财管理助力财务管控更高效",
        },
        {
          url: "/success-detail/8",
          image: require("@/assets/images/casesimg/huaxiafenmo.png"),
          imageLight: require("@/assets/images/casesimg/huaxiafenmo.png"),
          title: "华夏粉末冶金",
          content: "业财一体化应用为制造企业转型升级赋能",
        },
        {
          url: "/success-detail/1",
          image: require("@/assets/images/casesimg/guolv-new.png"),
          imageLight: require("@/assets/images/casesimg/guolv-new.png"),
          title: "中国国旅",
          content: "全球化财务共享中心管理",
        },
        {
          url: "/success-detail/2",
          image: require("@/assets/images/casesimg/botian-new.png"),
          imageLight: require("@/assets/images/casesimg/botian-new.png"),
          title: "博天环境 ",
          content: "智慧业财新共享平台",
        }
        ]
      ],
      companyall: [{
        logo: require('@/assets/images/home/anli/guolv.png'),
      }, {
        logo: require('@/assets/images/home/anli/botian.png'),
      }, {
        logo: require('@/assets/images/home/anli/zhiye.png'),
      }, {
        logo: require('@/assets/images/home/anli/chinazh.png'),
      }, {
        logo: require('@/assets/images/home/anli/luoyangzg.png'),
      }, {
        logo: require('@/assets/images/home/anli/chinams.png'),
      }, {
        logo: require('@/assets/images/home/anli/baoye.png'),
      }, {
        logo: require('@/assets/images/home/anli/zl.png'),
      }, {
        logo: require('@/assets/images/home/anli/enf.png'),
      }, {
        logo: require('@/assets/images/home/anli/jingye.png'),
      }, {
        logo: require('@/assets/images/home/anli/gangzhonglv.png'),
      }, {
        logo: require('@/assets/images/home/anli/meinuo.png'),
      }, {
        logo: require('@/assets/images/home/anli/zhongguojingye.png'),
      }, {
        logo: require('@/assets/images/home/anli/dutyzero.png'),
      }, {
        logo: require('@/assets/images/home/anli/19.png'),
      }, {
        logo: require('@/assets/images/home/anli/guoyao.jpg'),
      }, {
        logo: require('@/assets/images/home/anli/enfeihuaibao.png'),
      }, {
        logo: require('@/assets/images/home/anli/huiruizhiyao.gif'),
      }, {
        logo: require('@/assets/images/home/anli/nbtm.png'),
      }, {
        logo: require('@/assets/images/home/anli/boe.png'),
      }, {
        logo: require('@/assets/images/home/anli/shandongjingmi.png'),
      }, {
        logo: require('@/assets/images/home/anli/rsms.png'),
      }, {
        logo: require('@/assets/images/home/anli/nanjyy.png'),
      }, {
        logo: require('@/assets/images/home/anli/xinlvyao.png'),
      }, {
        logo: require('@/assets/images/home/anli/wuhanshizhongxinyiy.png'),
      }, {
        logo: require('@/assets/images/home/anli/aolinteyaoye.png'),
      }],
      valueBox: [
        [
          {
            img1: require("@/assets/images/portfolio/eec/01/value-icon1.png"),
            img2: require("@/assets/images/portfolio/eec/01/value-icon1-blue.png"),
            title: '业财融合',
            content: '多元化、多层级，因地制宜',
            content2: '推行业财融合'
          },
          {
            img1: require("@/assets/images/portfolio/eec/01/1589642.png"),
            img2: require("@/assets/images/portfolio/eec/01/1589642-01.png"),
            title: '解除困局',
            content: '破壁垒、通数据，解除业务',
            content2: '发展困局'
          },
          {
            img1: require("@/assets/images/portfolio/eec/01/value-icon3.png"),
            img2: require("@/assets/images/portfolio/eec/01/value-icon3_blue.png"),
            title: '助力经营',
            content: '控风险、创价值，业财融合',
            content2: '助力企业经营'
          },
        ],
        [
          {
            img1: require("@/assets/images/portfolio/eec/01/value-icon3.png"),
            img2: require("@/assets/images/portfolio/eec/01/value-icon3_blue.png"),
            title: '管理价值',
            content: '适配数字化时代和行业竞争格局，全面打造集团企业智慧财务管控体系。',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/01/1589642.png"),
            img2: require("@/assets/images/portfolio/eec/01/1589642-01.png"),
            title: '系统价值',
            content: '持续打造适配企业财务数字化战略的业财一体化信息体系，支撑企业财务管理的敏捷和解耦能力。',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/01/value-icon1.png"),
            img2: require("@/assets/images/portfolio/eec/01/value-icon1-blue.png"),
            title: '战略价值',
            content: '基于业财融合一体化的财务共享(中台)建设，助力企业财务数字化转型、重构业务竞争优势。',
            content2: ''
          },
        ],
        [
          {
            img1: require("@/assets/images/portfolio/eec/value-icon03-01.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon03-01_blue.png"),
            title: '业财税票深度融合',
            content: '打通业务、财务、税务、发票，实现全业务流程协同，打破信息孤岛，实现数据共享。',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon03-02.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon03-02_blue.png"),
            title: '提升用户体验',
            content: '实现全业务票夹报账，实现报账数据一键生成，提升用户体验。',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon03-03.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon03-03_blue.png"),
            title: '管控精细化',
            content: '票、款、单、账关联，基于事项会计方法，保留业务细节。',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon03-04.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon03-04_blue.png"),
            title: '深化财务数据价值',
            content: '基于集团涉税数据集中归集沉淀，形成企业数据中台，为全税种管理建设提供基础，提升税务管理效率。',
            content2: ''
          },
        ],
        [
          {
            img1: require("@/assets/images/industry/tbcore.png"),
            img2: require("@/assets/images/industry/1-lanse.png"),
            title: '提高资金使用率',
            content: '管理资金流动性和风险，降低融资成本，提高资金使用效率',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon04-02.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon04-02_blue.png"),
            title: '规划资金计划',
            content: '结合预算计划，规划企业短期的资金计划、中长期资金预算、项目资金预算等',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon04-03.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon04-03_blue.png"),
            title: '富余资金理财投资',
            content: '合理利用富余资金进行理财投资，并可有效结合企业所处行业特点和长期发展规划，匹配合适的资本结构',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon04-04.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon04-04_blue.png"),
            title: '协助拟定融资计划',
            content: '针对公司发展的目标、阶段性计划，协助相应的投融资计划',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon05-01.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon05-01_blue.png"),
            title: '预警提示',
            content: '对于涉及到资金风险的事项和问题，进行预警提示',
            content2: ''
          },
        ],
        [
          {
            img1: require("@/assets/images/portfolio/eec/value-icon05-01.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon05-01_blue.png"),
            title: '收款认领管理',
            content: '支持企业不同业务情况对未达账项的结转确认，对未达账项的二次业务确认并生成对应的收款单据及凭证。',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon05-02.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon05-02_blue.png"),
            title: 'RPA技术',
            content: '智慧网银云基于新兴RPA技术，实现对多个银行的网银对账单、网银电子回单、余额的自动下载（无需建立银企直联），并实现对于网银电子回单的结构化数据识别以及为后续电子回单进行电子档案管理提供基础。',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon05-03.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon05-03_blue.png"),
            title: '自动对账',
            content: '实现对于企业资金系统、总账系统、银行流水的全自动对账，并完成对账后电子回单与单据、凭证的一一对应，以及自动出具银行余额调节表。',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon05-04.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon05-04_blue.png"),
            title: '数据自动生成',
            content: '实现对于已下载银行流水及余额的银行账户的实时查询及流水分析需求。',
            content2: ''
          },
        ],
        [
          {
            img1: require("@/assets/images/portfolio/eec/value-icon06-01.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon06-01_blue.png"),
            title: '企业管理实效落实',
            content: '伴随全面预算管理的实行，使得企业领导者的管理侧重点逐渐聚焦到企业资源长远规划和下级的绩效评价上，企业内部的管理层级和模式，逐渐得以落实。',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon06-02.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon06-02_blue.png"),
            title: '企业战略目标落地',
            content: '通过实施全面预算管理，量化公司的经营目标、规范企业的管理控制、落实各责任中心的责任、明确各级责权、明确考核依据，为企业的成功提供了保证。全面预算管理实行的过程就是企业战略目标分解、实施、控制和实现的过程。',
            content2: ''
          },
        ],
        [
          {
            img1: require("@/assets/images/portfolio/eec/value-icon07-01.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon07-01_blue.png"),
            title: '一站式智能决策与分析的经营管理平台',
            content: '覆盖智能分析，全面预算，分析报表搭建业财一体绩效指标体系指引企业经营策略。',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon07-02.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon07-02_blue.png"),
            title: '一键实时获取经营数据',
            content: '通过分析业财融合实时数据，还原经营状况，支撑智能决策。',
            content2: ''
          },
          {
            img1: require("@/assets/images/portfolio/eec/value-icon07-03.png"),
            img2: require("@/assets/images/portfolio/eec/value-icon07-03_blue.png"),
            title: '为用户量身打造',
            content: '无需具备专业IT技能或繁琐培训，业务用户即可轻松上手。',
            content2: ''
          },
        ],
      ],
      valueBox4:[
        {
          img1: require("@/assets/images/industry/tbcore.png"),
          img2: require("@/assets/images/industry/1-lanse.png"),
          title: '提高资金使用率',
          content: '管理资金流动性和风险，降低融资成本，提高资金使用效率',
          content2: ''
        },
        {
          img1: require("@/assets/images/portfolio/eec/value-icon04-02.png"),
          img2: require("@/assets/images/portfolio/eec/value-icon04-02_blue.png"),
          title: '规划资金计划',
          content: '结合预算计划，规划企业短期的资金计划、中长期资金预算、项目资金预算等',
          content2: ''
        },
        {
          img1: require("@/assets/images/portfolio/eec/value-icon04-03.png"),
          img2: require("@/assets/images/portfolio/eec/value-icon04-03_blue.png"),
          title: '富余资金理财投资',
          content: '合理利用富余资金进行理财投资，并可有效结合企业所处行业特点和长期发展规划，匹配合适的资本结构',
          content2: ''
        },
        {
          img1: require("@/assets/images/portfolio/eec/value-icon04-04.png"),
          img2: require("@/assets/images/portfolio/eec/value-icon04-04_blue.png"),
          title: '协助拟定融资计划',
          content: '针对公司发展的目标、阶段性计划，协助相应的投融资计划',
          content2: ''
        },
        {
          img1: require("@/assets/images/portfolio/eec/value-icon07-03.png"),
          img2: require("@/assets/images/portfolio/eec/value-icon07-03_blue.png"),
          title: '预警提示',
          content: '对于涉及到资金风险的事项和问题，进行预警提示',
          content2: ''
        },
      ],
      demoClass: "col-lg-3 col-md-6 col-12",
      val: "",
      claWidth: 'col-lg-6',
      swiperOption: {
        speed: 1000,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination4",
          // clickable: true,
        },
        on: {
          slideChangeTransitionStart: () => {
            this.slideChangeTransitionStartHandle()
          },
        },
        observer: true,
        observeParents: true,
      },
      swiperOptions: {
        speed: 1000,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination1",
          clickable: true,
        },
        observer: true,
        observeParents: true,
      },
      swiperOptionAll: {
        speed: 1000,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        observer: true,
        observeParents: true,
      },
      valueData: [
        {
          title: "业务流程全覆盖",
          content:
            "财务共享全业务全流程覆盖，内部业务全面线上自动化",
        },
        {
          title: "核算自动化",
          content:
            "进一步提高核算自动化率，提升财务核算数据质量、审核工作效率，财务更加透明，财务核算和财务流程更加标准化和规范化",
        },
        {
          title: "良好的用户体验",
          content:
            "ECOP平台采用主流的界面设计规范，满足用户的操作体验，应用简单便捷，提高共享作业效率，并支持多端应用（PC\移动端）",
        },
        {
          title: "系统互联互通",
          content:
            "系统各模块间的穿透、追溯，实现系统内部的互联互通，提升数据管理价值",
        }
      ],
      groupData: [
        [{
          topTitle: '智慧业财一体化云',
          text: 'EECloud智慧业财一体化云基于具有PaaS能力的智慧创新平台ECOP，兼具业财融合、行业属性以及智能技术特色能力，是新一代面向集团企业、超大型集团企业等高端客户的全场景、一站式的业财融合一体化平台，以业财融合，对标世界一流，重构企业竞争优势。',
          img1: '',
          img2: require('@/assets/images/portfolio/eec/eec-group1.png'),
        }],
        [{
          topTitle: '智慧财务共享(中台)云',
          text: 'EECloud智慧财务共享（中台）云基于具有PaaS能力的智慧创新平台ECOP，兼具业财融合、行业属性以及智能技术特色能力，是新一代面向集团企业、超大型集团企业等高端客户的全场景、一站式的财务共享（中台）平台，促进业财一体化应用，优化升级财务管理体系，引领财务管理转型并助力公司战略落地。',
          img1: require('@/assets/images/portfolio/eec/eec-group2-1.png'),
          img2: require('@/assets/images/portfolio/eec/eec-group2-2.png'),
        }],
        [{
          topTitle: '税务管理云',
          text: '税务管理云可满足不同类型企业对发票、税务管理的目标，运用电子票夹、OCR影像识别等智能技术助力企业实现税务申报、税务核算、集中开票、收票和税务风险筹划等管理能力，覆盖全税种、全业务流程，从而打造从业务、财务到税务核算、纳税申报的“业财税一体化”企业智慧税务管理平台。',
          img1: require('@/assets/images/portfolio/eec/eec-group-3.png'),
          img2: '',
        }],
        [{
          topTitle: '全球司库管理云',
          text: '全球司库管理云旨在以资金集中和收支统一管理为核心，通过金融账户管理、融资管理、票据管理、供应链金融等信息化手段，提高企业资金运用效率，完成企业信用和金融资源的统筹分配与调度，有力监控企业金融资源，并提供有效的风险管理和科学的资金分析手段实现对企业战略决策支持。',
          img1: require('@/assets/images/portfolio/eec/eec-group4.png'),
          img2: '',
        }],
        [{
          topTitle: '智慧网银云',
          text: '智慧网银云依托AI+RPA技术，实现对多个银行电子回单自动下载，三单智能化匹配，单据、回单、凭证之间可相互穿透。结合收款认领功能，将企业电子回单进行结构化数据识别，实现统一的票据签收、回单电子化档案管理。通过对已下载银行流水及余额的银行账户的实时查询及流水分析，实现对企业资金项目的动态信息在线、集成和共享，可对企业资金项目事前、事中、事后全过程的实时监控管理。',
          img1: require('@/assets/images/portfolio/eec/eec-group5.png'),
          img2: '',
        }],
        [{
          topTitle: '全面预算管理云',
          text: '全面预算以企业发展战略为导向，根据周期内预算数据分析，实现系统间的全面联动以及多元数据的灵活调用，构建预算预警、动态调整、全周期闭环的预算管理机制，将预算期内经营管理目标，逐层分解、下达至企业内部各个单位，并以价值形式反映企业生产经营和财务活动的计划安排。',
          img1: '',
          img2: require('@/assets/images/portfolio/eec/eec-group6.png'),
        }],
        [{
          topTitle: '智能分析云',
          text: '智能决策与分析经营管理平台通过业财融合，能够深度分析业务、看清业务未来态势、将趋势抓得更准确，是企业经营管理的重要目标。智能分析平台能够实现更加精准的业务诊断分析，做好整个综合业绩管理的闭环。',
          img1: '',
          img2: require('@/assets/images/portfolio/eec/eec-group7.png'),
        }],
      ],
      valuesBoxs: [
        [
          { image: require('@/assets/images/portfolio/eec/02-01.png') }
        ],
        [
          { image: require('@/assets/images/portfolio/eec/02-02.png') }
        ],
        [
          { image: require('@/assets/images/portfolio/eec/02-03.png') }
        ],
        [
          { image: require('@/assets/images/portfolio/eec/02-04.png') }
        ],
        [
          { image: require('@/assets/images/portfolio/eec/02-05.png') }
        ],
        [
          { image: require('@/assets/images/portfolio/eec/02-06.png') }
        ],
        [
          { image: require('@/assets/images/portfolio/eec/02-07.png') }
        ],
      ],
      shows:false,
      modelBox: [
        [
          {
            img: require("@/assets/images/portfolio/eec/1.png"),
            title1: "智能合同管理平台",
            title2:
              "智能合同管理平台以项目、合同为源头的全生命周期的智能合同管理，包含合同评审、合同变更、合同结算、合同发票、合同收付款管理。",
          },
          {
            img: require("@/assets/images/portfolio/eec/1.png"),
            title1: "智慧业财管理平台",
            title2:
              "智慧业财管理平台智能报账、发票管理、一键报税、资金结算、电子影像、电子档案、智能技术、移动应用、项目管理和行业属性等全场景。",
          },
          {
            img: require("@/assets/images/portfolio/eec/1.png"),
            title1: "共享运营平台",
            title2:
              "任务提取规则、任务派单规则、单据模板设置、共享服务中心任务处理、作业任务管理、任务查询、绩效考评等模块。",
          },
          {
            img: require("@/assets/images/portfolio/eec/1.png"),
            title1: "行业特性",
            title2: "通过信息化推动企业标准化建设落地，实现管理制度化、制度流程化、流程表单化、表单信息化。",
          },
        ],
        [
          {
            img: require("@/assets/images/portfolio/eec/two-blue.png"),
            title1: "智能合同管理",
            title2: "智能合同管理平台以项目、合同为源头的全生命周期的智能合同管理",
          },
          {
            img: require("@/assets/images/portfolio/eec/two-blue.png"),
            title1: "智能报账",
            title2: "智能报账包括商旅和费控一体化管理、企业支出一体化管理",
          },
          {
            img: require("@/assets/images/portfolio/eec/two-blue.png"),
            title1: "发票管理",
            title2: "发票管理与智能报账、影像系统、税务管理一体化，实现进项发票的归集",
          },
          {
            img: require("@/assets/images/portfolio/eec/two-blue.png"),
            title1: "电子影像与电子档案管理",
            title2: "影像管理包括影像采集、影像处理、影像展现、影像存储等功能，实现业务系统运营",
          },
          {
            img: require("@/assets/images/portfolio/eec/two-blue.png"),
            title1: "一键报税",
            title2: "通过发票夹多种采集方式进行发票采集，与报账系统关联引用发票信息便捷填单",
          },
          {
            img: require("@/assets/images/portfolio/eec/two-blue.png"),
            title1: "资金结算",
            title2: "统一资金结算平台，实现资金业务处理信息化、自动化、不落地处理，提升结算效率",
          },
          {
            img: require("@/assets/images/portfolio/eec/two-blue.png"),
            title1: "移动应用",
            title2: "将费用报销与费用申请、事务申请金额管控、发票管控等集成",
          },
          {
            img: require("@/assets/images/portfolio/eec/two-blue.png"),
            title1: "连接器",
            title2: "将其他业务系统等无缝与财务共享（中台）整合，通过统一数据连接器充分结合",
          },
          {
            img: require("@/assets/images/portfolio/eec/two-blue.png"),
            title1: "会计引擎",
            title2: "通过会计引擎，智能化、自动化生成财务核算系统凭证，实现智能记账",
          },

          {
            img: require("@/assets/images/portfolio/eec/two-blue.png"),
            title1: "共享运营平台",
            title2: "共享运营平台作为共享服务中心人员日常工作、管理的主要平台",
          },
        ],
        [
          {
            img: require("@/assets/images/portfolio/eec/three-blue.png"),
            title1: "进项管理",
            title2:
              "进项管理实现发票采集、价税分离、报账、专票抵扣勾选、统计签名、进项转出等税务业务处理，系统出具抵扣明细及汇总表",
          },
          {
            img: require("@/assets/images/portfolio/eec/three-blue.png"),
            title1: "销项管理",
            title2:
              "销项管理实现开票申请，开票流程管理、开票限额拆分、余票管理，单张及批量开票、发票作废、发票冲红、发票打印等",
          },
          {
            img: require("@/assets/images/portfolio/eec/three-blue.png"),
            title1: "申报管理",
            title2: "系统支持全税种申报，可以依据企业性质选择报表。系统分为纳税申报、涉税查询、申报作废三大模块",
          },
        ],
        [
          {
            img: require("@/assets/images/portfolio/eec/three-blue.png"),
            title1: "账户管理",
            title2:
              "银行账户集中管理、集中监控，授权审批银行账户的开立、变更、撤销、使用等操作，账户管理实现对于银行账户集中管理控...",
          },
          {
            img: require("@/assets/images/portfolio/eec/three-blue.png"),
            title1: "资金结算",
            title2:
              "资金结算管理包括收付款、内部结算、资金的归集和划拨等功能，并提供大量的资金分析报表和系统业务预警报表...",
          },
          {
            img: require("@/assets/images/portfolio/eec/three-blue.png"),
            title1: "融资管理",
            title2:
              "融资管理提供集团和成员企业信贷业务全过程管理，实现集团信贷业务的流程化、规范化。通过系统可实时掌握银行授信...",
          },
          {
            img: require("@/assets/images/portfolio/eec/three-blue.png"),
            title1: "资金集中管理",
            title2:
              "帮助企业建立资金集中管理和资金集中监控的平台，实现账户集中管控和实时监控，并实现收支两条线的资金管理模式...",
          },
          {
            img: require("@/assets/images/portfolio/eec/three-blue.png"),
            title1: "票据管理",
            title2:
              "票据管理为企业提供票据的收发、背书、贴现到期收付、质押、托管等业务的集中处理平台，帮助企业实现票据的全生命周期管理...",
          },
          {
            img: require("@/assets/images/portfolio/eec/three-blue.png"),
            title1: "供应链金融",
            title2:
              "供应链金融应用于供应链融资流程、风控管理授信评分、贷后监控等方面，从而实现融资申请贷前调查、贷款审核、催收管理流程化...",
          },
        ],
        [
          {
            img: require("@/assets/images/portfolio/eec/1.png"),
            title1: "收款认领",
            title2:
              "通过RPA技术将所有收款信息形成结构化数据导入收款认领模块，形成收款单据，同时下载对应收款回单附件信息，将回单信息同步...",
          },
          {
            img: require("@/assets/images/portfolio/eec/1.png"),
            title1: "资金监控",
            title2:
              "对企业资金流入流出情况、实时余额、当月总流入、当月总流出等参数进行实时监控查看。同时涵盖资金付款预测、资金头寸预测...",
          },
          {
            img: require("@/assets/images/portfolio/eec/1.png"),
            title1: "银行对账",
            title2:
              "自动将银行流水（收/付）与资金结算模块数据进行核对，将每一笔流水明细与每一笔结算单据进行关联核对，最终形成比对差异...",
          },
          {
            img: require("@/assets/images/portfolio/eec/1.png"),
            title1: "票据管理",
            title2:
              "票据管理和收款认领为企业两大主要资金流入来源，票据签收具有数据下载勾选认领模式，在票据勾选签收后RPA自动登录网银...",
          },
        ],
        [
          {
            img: require("@/assets/images/portfolio/eec/three-blue.png"),
            title1: "进项管理",
            title2:
              "进项管理实现发票采集、价税分离、报账、专票抵扣勾选、统计签名、进项转出等税务业务处理，系统出具抵扣明细及汇总表",
          },
          {
            img: require("@/assets/images/portfolio/eec/three-blue.png"),
            title1: "销项管理",
            title2:
              "销项管理实现开票申请，开票流程管理、开票限额拆分、余票管理，单张及批量开票、发票作废、发票冲红、发票打印等",
          },
          {
            img: require("@/assets/images/portfolio/eec/three-blue.png"),
            title1: "申报管理",
            title2: "系统支持全税种申报，可以依据企业性质选择报表。系统分为纳税申报、涉税查询、申报作废三大模块",
          },
        ],
        [
          {
            img: require("@/assets/images/portfolio/eec/1.png"),
            title1: "智能报表",
            title2: "智能报表支持在多会计准则、多币种、法定及管理多组织架构等各种复杂环境下准确、自动生成报表。",
          },
          {
            img: require("@/assets/images/portfolio/eec/1.png"),
            title1: "智能分析管理",
            title2:
              "智能分析通过业财数据中台，对企业过去、评价企业现状、预测企业未来做出正确决策提供准确的信息和依据。",
          },
        ],
      ],
    }
  },
  created() {
    this.valType()
  },
  computed: {
    defaultOption() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  watch: {
    $route() {
      this.valType()
    }
  },
  mounted() {
    console.log("页面实时宽度", this.windowWidth)
    console.log(this.Swiper)
  },
  methods: {
    slideChangeTransitionStartHandle() {
      let swiper = this.$refs.Swipers.swiper ? this.$refs.Swipers.swiper.realIndex : 0
      for (let i = 1; i < 5; i++) {
        let ids1 = i + "1"
        let ids2 = i + "2"
        if (document.getElementById(ids1).getAttribute("class").indexOf('line') != -1) {
          document.getElementById(ids1).classList.remove("line")
        }
        if (document.getElementById(ids2).getAttribute("class").indexOf('content') != -1) {
          document.getElementById(ids2).classList.remove("content")
        }
      }
      for (let i = 1; i < Number(swiper) + 2; i++) {
        let ids1 = i + "1"
        let ids2 = i + "2"
        document.getElementById(ids1).classList.add("line");
        document.getElementById(ids2).classList.add("content");
        // document.getElementById(ids1).setAttribute("class", "line")
        // document.getElementById(ids2).setAttribute("class", "content")
      }
    },
    title(val) {
      this.$router.push({
        path: '/counter/' + val
      })
      this.val = val
    },
    valType() {
      this.val = this.$route.params.type
    },
    goRouter() {
      this.$router.push({
        path: "/call-us"
      })
    },
    orderShow() {
      this.shows = true
    },
    close(){
      this.shows = false
    },
  },
}
</script>


<style lang="scss">

</style>